export default __webpack_public_path__ + "static/media/LineSaleMockHuman.d5ce8088.png";